import React, { useEffect, useState } from 'react';
import withQuillLayout from '@Common/hoc/QuillLayout';
import { RootState } from '@Common/models/redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { userCreditsWithRetry } from 'src/plagiarism-checker/handlers/logic';
import { getUserScanHistory } from 'src/plagiarism-checker/handlers/api';
import dynamic from 'next/dynamic';
import QuillLocalStorage from 'core/utils/localStorageClient';

const PlagCheckTool = dynamic(() => import('src/plagiarism-checker/components/PlagCheckToolNew'), {
  ssr: true,
});
const PlagiarismCheckHome = dynamic(
  () => import('src/plagiarism-checker/components/PlagiarismCheckHome'),
  {
    ssr: true,
  }
);

const PlagiarismChecker = () => {
  const userCredits = useSelector((state: RootState) => state.plac.controls.userCredits);
  const user = useSelector((state: RootState) => state.user);
  const isSyncWithDB = useSelector((state: RootState) => state.user.syncedWithDb || false);
  const dispatch = useDispatch();
  const [isScanHistoryPresent, setIsScanHistoryPresent] = useState(false);

  // useEffect(() => {
  //   const hidePlagiarismBanner = QuillLocalStorage.getInstance().get(
  //     'hidePlagiarismBanner',
  //     'false'
  //   );
  //   if (hidePlagiarismBanner === 'false') {
  //     QuillLocalStorage.getInstance().set('hidePlagiarismBanner', 'true');
  //   }
  // }, []);

  useEffect(() => {
    if (isSyncWithDB && user.isAuthenticated) {
      userCreditsWithRetry(dispatch);
      const plagCheckScanHistory =
        QuillLocalStorage.getInstance().get('plagCheckScanHistory', 'false') === 'true';

      if (plagCheckScanHistory) {
        setIsScanHistoryPresent(true);
      } else {
        getUserScanHistory(1, 10)
          .then(({ scanHistory: scnHistory }) => {
            QuillLocalStorage.getInstance().set(
              'plagCheckScanHistory',
              scnHistory.length > 0 ? 'true' : 'false'
            );
            setIsScanHistoryPresent(scnHistory.length > 0);
          })
          .catch((error) => {
            // eslint-disable-next-line no-console
            console.log('error', error);
          });
      }
    }
  }, [isSyncWithDB]);

  return user.isAuthenticated &&
    (isScanHistoryPresent || user.premium || userCredits.available_purchased_credit > 0) ? (
    // eslint-disable-next-line react/jsx-indent
    <PlagCheckTool />
  ) : (
    <PlagiarismCheckHome />
  );
};

export default withQuillLayout({
  children: PlagiarismChecker,
});
